import { createElement, Fragment, useEffect, type ReactNode } from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { useLanguage } from '../context/LanguageContext';
import { SiteLink } from './SiteLink';

interface Props { html: string; title: string; description?: string; knowledge?: Record<string, Record<string,string>>; slots?: Record<string, ReactNode>; }

export function HtmlPage({ html, title, description='', knowledge={}, slots={} }: Props) {
 const {language,t}=useLanguage();
 useEffect(()=>{
   document.title=title;
   const meta=document.querySelector('meta[name="description"]'); if(meta) meta.setAttribute('content',description||'J’aime Fine Jewellery');
 },[title,description]);
 const localKnowledge=knowledge[language]||knowledge.en||{};
 const options:any={replace:(node:any)=>{
   if(node.type!=='tag') return undefined;
   if(node.name==='script') return <Fragment/>;
   const a=node.attribs||{};
   if(a['data-lang'] && a['data-lang']!==language) return <Fragment/>;
   const classes=(a.class||'').split(/\s+/);
   if(classes.some((x:string)=>/^k-(en|zh|fr)$/.test(x)) && !classes.includes(`k-${language}`)) return <Fragment/>;
   if(a.id && slots[a.id]) return <Fragment key={a.id}>{slots[a.id]}</Fragment>;
   const slotClass=(a.class||'').split(/\s+/).find((x:string)=>slots[`class:${x}`]);
   if(slotClass) return <Fragment key={slotClass}>{slots[`class:${slotClass}`]}</Fragment>;
   const props=attributesToProps(a) as Record<string,unknown>;
   if('fetchpriority' in props){props.fetchPriority=props.fetchpriority;delete props.fetchpriority;}
   const children=domToReact(node.children||[],options);
   if('fetchpriority' in a) return createElement(node.name,props);
   if(node.name==='a' && a.href) return <SiteLink {...props as any} href={a.href}>{children}</SiteLink>;
   if(a['data-i18n-html']) return createElement(node.name,props,parse(t(a['data-i18n-html'],''),options));
   if(a['data-i18n']) return createElement(node.name,props,t(a['data-i18n'],String(children||'')));
   if(a['data-k']) return createElement(node.name,props,parse(localKnowledge[a['data-k']]??String(children||''),options));
   return undefined;
 }};
 return <>{parse(html,options)}</>;
}
